import { render } from "./MngLog.vue?vue&type=template&id=248babb1&scoped=true&ts=true"
import script from "./MngLog.vue?vue&type=script&lang=ts"
export * from "./MngLog.vue?vue&type=script&lang=ts"

import "./MngLog.vue?vue&type=style&index=0&id=248babb1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-248babb1"]])

export default __exports__